// moz667: por culpa de vrdemo
var $ = jQuery;

// Videos modales
$(".modal-video").each(function () {
    var $link = $(this);
    var message = "";

    /* */
    // https://drive.google.com/file/d/14T3i_Zc5QYf2yIhLXWv3nt9uFnXbfghM/view

    if (is_embedable_link($link)) {
        var video_player_url = $link.attr("href");

        if (is_3rdparty_link($link)) {
            if (is_vimeo_video_url(video_player_url)) {
                video_player_url = video_player_url.replace('//vimeo.com/', '//player.vimeo.com/video/');
            }
    
            if (is_google_drive_video_url(video_player_url)) {
                video_player_url = video_player_url.replace(/\/view$/g, '/preview');
            }
    
            message = '<iframe class="modal-video" src="' + video_player_url + '" width="640" height="360" frameborder="0" allowfullscreen autoplay></iframe>';
    
        } else {
            message = '<video width="640" height="360" controls><source src="' + video_player_url + '" type="video/mp4"></video>';
        }
    }

    $link.on("click", function (e) {
        e.preventDefault();

        if (is_embedable_link($link)) {
            alertDialog.show({
                title: $link.attr("title"),
                dialogSize: "lg",
                message: message,
                onHide: function () {
                    if (is_3rdparty_link($link)) {
                        $("#alertDialog iframe.modal-video").remove();
                    }

                    audit_click($link, "hide");
                },
                onShow: function () {
                    audit_click($link, "show");
                }
            });
        } else {
            audit_click($link, "show");
            open_in_new_tab($link.attr("href"));
        }
    });
});

function open_in_new_tab(url) {
    var win = window.open(url, '_blank');
    win.focus();
}

function audit_click($link, event_tag) {
    if (N2M.AUDIT_CLICK_URL) {
        var extra_click_info = $link.data('extra');
        if (extra_click_info) {
            var current_page = document && document.location ? document.location.pathname : 'unknown';

            $.ajax({
                method: "GET", // FIXME: hacer que sea POST, por ahora es GET ya que si no tenemos que lidiar con el CSRF
                url: N2M.AUDIT_CLICK_URL,
                data: {
                    p: current_page,
                    e: extra_click_info + ";" + event_tag
                }
            });
        }
    }
}

function is_3rdparty_link($link) {
    return !$link.data("self-hosted");
}

function is_embedable_link($link) {
    var url = $link.attr("href");

    return !is_3rdparty_link($link) || is_vimeo_video_url(url) || 
        is_youtube_video_url(url) || is_google_drive_video_url(url);
}

function is_vimeo_video_url(url) {
    return url && (
        url.startsWith("https://vimeo.com/") ||
        url.startsWith("https://player.vimeo.com/") ||
        url.startsWith("http://vimeo.com/") ||
        url.startsWith("http://player.vimeo.com/")
    );
}

function is_youtube_video_url(url) {
    return url && (
        url.startsWith("https://www.youtube.com/embed/") ||
        url.startsWith("http://www.youtube.com/embed/")
    );
}

/*
http://www.youtube.com/v/-wtIMTCHWuI?version=3&autohide=1
https://www.youtube.com/v/0zM3nApSvMg?fs=1&amp;hl=en_US&amp;rel=0
http://www.youtube.com/oembed?url=http%3A//www.youtube.com/watch?v%3D-wtIMTCHWuI&format=json
http://www.youtube.com/attribution_link?a=JdfC0C9V6ZI&u=%2Fwatch%3Fv%3DEhxJLojIE_o%26feature%3Dshare
https://www.youtube.com/attribution_link?a=8g8kPrPIi-ecwIsS&u=/watch%3Fv%3DyZv2daTWRZU%26feature%3Dem-uploademail
https://www.youtube.com/user/IngridMichaelsonVEVO#p/a/u/1/QdK8U-VIH_o
//www.youtube-nocookie.com/embed/up_lNV-yoK4?rel=0
https://www.youtube-nocookie.com/embed/up_lNV-yoK4?rel=0
http://www.youtube.com/user/Scobleizer#p/u/1/1p3vcRhsYGo
http://www.youtube.com/ytscreeningroom?v=NRHVzbJVx8I
http://www.youtube.com/user/Scobleizer#p/u/1/1p3vcRhsYGo?rel=0
http://youtube.com/?vi=dQw4w9WgXcQ&feature=youtube_gdata_player
http://youtube.com/watch?vi=dQw4w9WgXcQ&feature=youtube_gdata_player
http://youtube.com/vi/dQw4w9WgXcQ?feature=youtube_gdata_player
http://www.youtube.com/user/SilkRoadTheatre#p/a/u/2/6dwqZw0j_jY
http://youtube.com/v/dQw4w9WgXcQ?feature=youtube_gdata_player
http://youtube.com/?v=dQw4w9WgXcQ&feature=youtube_gdata_player
http://www.youtube.com/v/0zM3nApSvMg?fs=1&hl=en_US&rel=0
http://www.youtube.com/ytscreeningroom?v=oTJRivZTMLs
*/

/*
http://www.youtube.com/watch?v=-wtIMTCHWuI
http://youtu.be/-wtIMTCHWuI
https://www.youtube.com/watch?v=yZv2daTWRZU&feature=em-uploademail
https://www.youtube.com/watch?v=0zM3nApSvMg&feature=feedrec_grec_index
http://www.youtube.com/watch?v=0zM3nApSvMg&feature=feedrec_grec_index
https://www.youtube.com/watch?v=0zM3nApSvMg#t=0m10s
http://www.youtube.com/watch?v=0zM3nApSvMg#t=0m10s
https://www.youtube.com/embed/0zM3nApSvMg?rel=0
http://www.youtube.com/watch?v=cKZDdG9FTKY&feature=channel
http://www.youtube.com/watch?v=0zM3nApSvMg&playnext_from=TL&videos=osPknwzXEas&feature=sub
http://www.youtube.com/watch?v=6dwqZw0j_jY&feature=youtu.be
http://www.youtube.com/embed/nas1rJpm7wY?rel=0
https://www.youtube.com/watch?v=0zM3nApSvMg
http://www.youtube.com/watch?v=dQw4w9WgXcQ&feature=youtube_gdata_player
http://youtube.com/watch?v=dQw4w9WgXcQ&feature=youtube_gdata_player
http://youtu.be/dQw4w9WgXcQ?feature=youtube_gdata_player
https://www.youtube.com/watch?v=ishbTyLs6ps&list=PLGup6kBfcU7Le5laEaCLgTKtlDcxMqGxZ&index=106&shuffle=2655
http://www.youtube.com/embed/dQw4w9WgXcQ
http://www.youtube.com/v/dQw4w9WgXcQ
http://www.youtube.com/e/dQw4w9WgXcQ
http://www.youtube.com/?v=dQw4w9WgXcQ
http://www.youtube.com/watch?feature=player_embedded&v=dQw4w9WgXcQ
http://www.youtube.com/?feature=player_embedded&v=dQw4w9WgXcQ
http://www.youtube.com/user/IngridMichaelsonVEVO#p/u/11/KdwsulMb8EQ
http://www.youtube-nocookie.com/v/6L3ZvIMwZFM?version=3&hl=en_US&rel=0
http://www.youtube.com/user/dreamtheater#p/u/1/oTJRivZTMLs
https://youtu.be/oTJRivZTMLs?list=PLToa5JuFMsXTNkrLJbRlB--76IAOjRM9b
http://www.youtube.com/watch?v=oTJRivZTMLs&feature=youtu.be
http://youtu.be/oTJRivZTMLs?feature=channel
http://www.youtube.com/embed/oTJRivZTMLs?rel=0
http://youtube.com/vi/oTJRivZTMLs&feature=channel
http://youtube.com/?v=oTJRivZTMLs&feature=channel
http://youtube.com/?feature=channel&v=oTJRivZTMLs
http://youtube.com/?vi=oTJRivZTMLs&feature=channel
http://youtube.com/watch?v=oTJRivZTMLs&feature=channel
http://youtube.com/watch?vi=oTJRivZTMLs&feature=channel
https://m.youtube.com/watch?v=m_kbvp0_8tc
*/

function is_google_drive_video_url(url) {
    return url && (
        url.startsWith("http://drive.google.com/") ||
        url.startsWith("https://drive.google.com/")
    ) && (url.endsWith("/preview") || url.endsWith("/view"));
}